export const checkFileSize = (fileSize) => {
	if (fileSize >= (1e8).toFixed(8)) {
		return false
	}
	return true
}
